import React from 'react';
import { Languages } from 'lucide-react';
import { useTrainingLang } from '../i18n/TrainingLangContext';

/**
 * Always-visible language toggle in the training tile header.
 *
 * Switching is safe at any point, including mid-quiz: option identity is canonical in
 * the database, so the text changes language while already-selected answers stay
 * selected.
 */
const LanguageSwitcher = ({ compact = false }) => {
  const { language, languages, setLanguage, t } = useTrainingLang();

  return (
    <div
      className="flex items-center gap-1 bg-slate-700/60 rounded-md p-1"
      title={t('changeLanguage')}
    >
      {!compact && <Languages className="w-4 h-4 text-slate-300 ml-1 mr-0.5" />}
      {languages.map((l) => {
        const active = l.code === language;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setLanguage(l.code)}
            aria-pressed={active}
            className={`px-2.5 py-1 rounded text-xs font-medium transition-colors ${
              active
                ? 'bg-amber-600 text-white'
                : 'text-slate-300 hover:bg-slate-600 hover:text-white'
            }`}
          >
            {l.nativeLabel}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
